import React from 'react';
import PropTypes from 'prop-types';
import { AutoMetricContext } from "./context";
import { ChildrenMutationObserver } from "./utils/ChildrenMutationObserver";
import { ChildrenRefObserver } from "./utils/ChildrenRefObserver";
import { AutoMetricBlockType, AutoMetricEventType } from "../core";
import { useAutoMetricBranch } from "./hooks/useAutoMetricBranch";
import { useDynamicIntersection } from "./utils/useDynamicIntersection";
import { useAutoMetricNodeParams } from "./hooks/useAutoMetricParams";
import { debugLevel } from "../logger";
import { DebugLevel } from "../logger/debug";
import { getComponentTestId } from "../core/dom";
var debugHighlight = function debugHighlight(el) {
  var domNode = el.target;
  domNode.style.outline = '3px solid rgba(255,0,0,0)';
  domNode.style.transition = 'outline-color .3s ease-in-out';
  domNode.style.outline = '3px solid rgba(255,0,0, 1)';
  setTimeout(function () {
    domNode.style.outline = '3px solid rgba(255,0,0,0)';
  }, 1500);
};
export var AutoMetricElement = function AutoMetricElement(_ref) {
  var children = _ref.children,
    type = _ref.type,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    asChildRef = _ref.asChildRef;
  var ChildrenObserver = asChildRef ? ChildrenRefObserver : ChildrenMutationObserver;
  var metric = useAutoMetricBranch(type);
  useAutoMetricNodeParams(metric.node, params);
  var onObservedNodesChange = useDynamicIntersection(function (entries, observer) {
    entries.forEach(function (el) {
      if (el.isIntersecting) {
        if (debugLevel === DebugLevel.FULL) debugHighlight(el);
        metric.api.publish(AutoMetricEventType.VIEW, metric.node, {
          goal: metric.goals[AutoMetricEventType.VIEW],
          name: getComponentTestId(el.target),
          element: el.target
        });
        observer.disconnect();
      }
    });
  });
  var shouldObserveNode = type !== AutoMetricBlockType.ELEMENT;
  return /*#__PURE__*/React.createElement(AutoMetricContext.Provider, {
    value: metric
  }, /*#__PURE__*/React.createElement(ChildrenObserver, {
    elementsRef: shouldObserveNode ? onObservedNodesChange : undefined,
    refName: typeof asChildRef === 'string' ? asChildRef : undefined,
    "data-t-id": "src-react"
  }, children));
};
AutoMetricElement.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.oneOf(Object.values(AutoMetricBlockType)),
  params: PropTypes.any,
  children: PropTypes.node
} : {};